import { useState, useEffect } from "react";

// T is a generic type for the value that is being debounced.
function useDebounce<T>(value: T, delay: number): T {
  // State to store the debounced value
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(
    () => {
      // Set up a timer to update the debounced value after the specified delay
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      // This is the cleanup function. It will be called if:
      // 1. The component unmounts.
      // 2. The `value` or `delay` changes before the timer finishes.
      // This is crucial to prevent the old timer from firing.
      return () => {
        clearTimeout(handler);
      };
    },
    [value, delay] // Only re-run the effect if value or delay changes
  );

  return debouncedValue;
}

export default useDebounce;
